/* eslint-disable no-shadow */

import {
  SEARCH_RESULT_TOTAL_COUNT,
  SEARCH_RESULTS,
} from "@polygon-software/bomify/src/constants/SEARCH.js";

const state = () => ({
  search_result: {
    [SEARCH_RESULTS]: [],
    [SEARCH_RESULT_TOTAL_COUNT]: 0,
  },
});

const getters = {
  getSearchResult(state) {
    return state.search_result;
  },
};

const mutations = {
  setSearchResult(state, searchResult) {
    state.search_result = searchResult;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
